// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"338":"819ac86d","578":"19df2466"}[chunkId] + ".chunk.css";
};